var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegendOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 17 3 5H2l3-5zm16 1v2H9v-2h12zM7 10v4H3v-4h4zm14 1v2H9v-2h12zM5 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm16 1v2H9V4h12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendOpen);
export default __webpack_public_path__ + "static/media/legend_open.3d941d39896e43738c978c15af7a557b.svg";
export { ForwardRef as ReactComponent };